import findAllFor from './find-all-for';

export default {
  findAllFor,
};
